import { useFormik } from 'formik';

const useForm = ({
  initialValues,
  onSubmit,
  validationSchema,
  enableReinitialize = false,
  validateOnMount = false,
}) => {
  const {
    handleChange,
    handleSubmit,
    handleBlur,
    setFieldValue,
    setValues,
    values,
    touched,
    errors,
    isValid,
    dirty,
    resetForm,
    validateForm,
    setFieldError,
    validateField,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize,
    validateOnMount,
  });

  const inputError = name => touched[name] && errors[name];
  const disabledSubmit = !isValid || !dirty;

  return {
    handleChange,
    handleBlur,
    handleSubmit,
    values,
    inputError,
    disabledSubmit,
    setFieldValue,
    setValues,
    resetForm,
    isValid,
    validateForm,
    setFieldError,
    dirty,
    validateField,
    errors,
  };
};

export default useForm;
